import React, { useEffect, useState } from 'react';
import PortfolioAdmin from './PortfolioAdmin';
import ServicesAdmin from './ServicesAdmin';
import QuotesAdmin from './QuotesAdmin';
import { useNavigate } from 'react-router-dom';
import { me, logout as apiLogout } from './api';

export default function AdminPanel() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = React.useState<'portfolio'|'services'|'quotes'>('portfolio');
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    me()
      .then(data => { if (!mounted) return; setUser(data); })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
    return () => { mounted = false; };
  }, []);

  async function logout() {
    try {
      await apiLogout();
    } catch(e) {
      // ignore errors but proceed to login route
    }
    navigate('/admin/login');
  }

  if (loading) return <div className="p-8">Checking session...</div>;
  if (!user || user.role !== 'admin') {
    // not authenticated
    return (
      <div className="p-8">
        <p className="mb-4">You are not logged in as an admin.</p>
        <button onClick={() => navigate('/admin/login')} className="bg-sky-600 text-white px-3 py-1 rounded">Go to login</button>
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#0f172a] p-6">
      <div className="max-w-6xl mx-auto bg-white dark:bg-slate-800 p-6 rounded shadow">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl text-slate-800 dark:text-slate-100">Admin Panel</h1>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-600 dark:text-slate-300">{user.username}</span>
            <button onClick={logout} className="text-sm bg-rose-500 text-white px-3 py-1 rounded">Logout</button>
          </div>
        </div>

        <div className="mb-4">
          <nav className="flex gap-2">
            <button onClick={() => setTab('portfolio')} className={`px-3 py-2 rounded ${tab==='portfolio' ? 'bg-sky-600 text-white' : 'border'}`}>Portfolio</button>
            <button onClick={() => setTab('services')} className={`px-3 py-2 rounded ${tab==='services' ? 'bg-sky-600 text-white' : 'border'}`}>Services</button>
            <button onClick={() => setTab('quotes')} className={`px-3 py-2 rounded ${tab==='quotes' ? 'bg-sky-600 text-white' : 'border'}`}>Quotes</button>
          </nav>
        </div>

        <div className="mt-4">
          {tab === 'portfolio' && <div className="bg-white p-4 rounded"><PortfolioAdmin /></div>}
          {tab === 'services' && <div className="bg-white p-4 rounded"><ServicesAdmin /></div>}
          {tab === 'quotes' && <div className="bg-white p-4 rounded"><QuotesAdmin /></div>}
        </div>
      </div>
    </div>
  );
}
